import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('agents', { routeName: 'frontdoorResourceRoute' })
export class Agent extends Resource {
    id: string;
    status: string;
    selected = false;
    description: string;
    envZId: string;
    zId: string;
    host: string;
}


